import fastenLogo from '../assets/icons/fasten-logo-green.svg';
import VehicleEntryForm from '../components/VehicleEntryForm';

export default function VehicleEntryPage() {
  return (
    <div className="min-h-screen flex flex-col bg-gray-100 font-sans pt-8 md:py-24 md:items-center md:justify-center">
      <img src={fastenLogo} alt="Fasten Logo" className="w-40 h-auto mb-6 mt-2 mx-auto md:mx-0" />
      <div className="bg-white rounded-none md:rounded-[12px] p-6 flex flex-col items-center mx-auto w-full max-w-full md:max-w-md border-t border-gray-200 md:border md:border-gray-200 flex-1 md:flex-none">
        <VehicleEntryForm />
      </div>
    </div>
  );
} 